import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "xxqd" }
const _hoisted_2 = { class: "channel-img" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "xsqd" }
const _hoisted_5 = { class: "channel-img" }
const _hoisted_6 = ["src"]

import { ref, onMounted } from 'vue'
import BannerC from '@/components/BannerC.vue';
import { asynchronousRetrieval } from '@/utils'


export default /*@__PURE__*/_defineComponent({
  __name: 'ChannelExpansion',
  setup(__props) {

onMounted(async() => {
  const channel1: any = await asynchronousRetrieval('nfznxr-images/channel1.png');
  const channel2: any = await asynchronousRetrieval('nfznxr-images/channel2.png');
  loadUrl.value = { channel1, channel2 }
})
const loadUrl: any = ref({})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(BannerC),
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"title-font-style\" data-v-fda100ea>线下渠道</div><div class=\"text\" data-v-fda100ea><div class=\"p1\" data-v-fda100ea><span data-v-fda100ea>年平均增长</span><span class=\"keynote\" data-v-fda100ea>59%</span><span data-v-fda100ea> 遍布数百城市 </span><span class=\"keynote\" data-v-fda100ea>6000+</span><span data-v-fda100ea> 渠道</span></div><div class=\"p2\" data-v-fda100ea><span data-v-fda100ea>覆盖 </span><span class=\"keynote\" data-v-fda100ea>华东、华南、华北、西南 </span><span data-v-fda100ea>等消费活跃城市，同时全国渠道网络正在加速建立</span></div><div class=\"p2\" data-v-fda100ea><span data-v-fda100ea>2016年以来销售额平均年增长率</span><span class=\"keynote\" data-v-fda100ea> 59%</span><span data-v-fda100ea>，凝丰智能渠道销售额占行业整体销售额</span><span class=\"keynote\" data-v-fda100ea> 60%+</span></div></div>", 2)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: loadUrl.value.channel1
        }, null, 8, _hoisted_3)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"title-font-style\" data-v-fda100ea>线上渠道</div><div class=\"text\" data-v-fda100ea><div class=\"p1\" data-v-fda100ea><span data-v-fda100ea>覆盖 </span><span class=\"keynote\" data-v-fda100ea>10+</span><span data-v-fda100ea> 平台 引流 </span><span class=\"keynote\" data-v-fda100ea>百万</span><span data-v-fda100ea> 流量</span></div><div class=\"p2\" data-v-fda100ea><span data-v-fda100ea>构建完善的线上流量平台矩阵，与线下渠道形成互补优势，在线销售量常年位居平台销量前列 </span></div></div>", 2)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("img", {
          src: loadUrl.value.channel2
        }, null, 8, _hoisted_6)
      ])
    ])
  ]))
}
}

})